// extracted by mini-css-extract-plugin
export default {"moveButton":"MoveButton_moveButton__7snmf"};